export const SimulationTypes = {
  ISimulateLoad: Symbol("ISimulateLoad"),
};
